/**
 * BKM Muat API Configuration
 * Centralized API endpoint constants
 */

export const BKM_MUAT_API_CONFIG = {
    endpoints: {
        SUMMARY: '/odoo/sakti/bkm-muat',
    }
} as const;
